import { NumberFilterOptions, TopFilterGroup } from "components/config/grid-templates/predefined-filters";
import { setTopFilter } from "store/current-dashboard";
import { getUpdatedFilterModelForTopFilter } from "./filter-helpers";
export const handleEmptyFilterModel = (gridApi) => {
    if (!gridApi) {
        return;
    }
    gridApi.removeRowGroupColumns([TopFilterGroup.customGroup]);
    if (gridApi.getColumn(TopFilterGroup.customGroup)?.getColDef()?.hide) {
        gridApi.setColumnsVisible([TopFilterGroup.customGroup], false);
    }
};
export const extractFilterModel = (savedModel, colId) => {
    if (!savedModel || !savedModel[colId]) {
        return null;
    }
    return Array.isArray(savedModel[colId]?.filterModels)
        ? savedModel[colId]?.filterModels[0]
        : savedModel[colId];
};
export const handleTopBottomFilter = (grid, dispatch, model, colId, sectionId, widgetId) => {
    if (!model || !sectionId || !widgetId) {
        return;
    }
    const isTopOrBottom = model.type === NumberFilterOptions.top || model.type === NumberFilterOptions.bottom;
    if (!isTopOrBottom) {
        return;
    }
    dispatch(setTopFilter({
        filterColumnId: colId,
        filterDirection: model.type,
        filterRowCountLimit: model.filter,
        sectionId,
        widgetId
    }));
    grid.current?.api?.getRowGroupColumns().forEach((e) => {
        grid.current?.api?.removeRowGroupColumns([e.colId]);
    });
    grid.current?.api?.addRowGroupColumns([TopFilterGroup.customGroup]);
    grid.current?.api?.applyColumnState({
        defaultState: { sort: null },
        state: [
            {
                colId: TopFilterGroup.customGroup,
                sort: model.type === NumberFilterOptions.top ? "desc" : "asc"
            }
        ]
    });
};
export const createFilterChangedHandler = (grid, dispatch, sectionId, widgetId) => (event) => {
    if (!event.columns || event.columns.length === 0) {
        return;
    }
    const [{ colId }] = event.columns;
    const savedModel = getUpdatedFilterModelForTopFilter(grid.current?.api.getFilterModel(), colId);
    grid.current?.api.setFilterModel(savedModel);
    if (!savedModel) {
        return;
    }
    if (Object.keys(savedModel).length === 0) {
        handleEmptyFilterModel(grid.current?.api);
        return;
    }
    const model = extractFilterModel(savedModel, colId);
    handleTopBottomFilter(grid, dispatch, model, colId, sectionId, widgetId);
};
